const stepSequence = [
    'lensType',
    'lensTypeVariant',
    'prescription',
    'prescriptionUpload',
    'prescriptionForm',
    'prescriptionValidation',
    'lensPackage',
    'lensAddOn',
    'lensAddOnVariant', 
];

export { stepSequence };
//# sourceMappingURL=index.js.map
